
import { Vue, Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
  ChannelChangeAction,
  ChannelChangeGetter
} from "@/components/channelChange/types";
import { Namespace } from "@/store/types";
import apiStorageInterface from "@/services/apiStorageInterface";
import { MyChannel } from "@/services/apiService/api.types";

@Component({})
export default class ChannelChange extends Vue {
  @Action(ChannelChangeAction.UpdateChannelChange, {
    namespace: Namespace.ChannelChange
  })
  showChannelChange!: (show: boolean) => void;

  @Action(ChannelChangeAction.UpdateChannelNumber, {
    namespace: Namespace.ChannelChange
  })
  updateChanelNumber!: (digit?: number) => void;

  @Action(ChannelChangeAction.UpdateSource, {
    namespace: Namespace.ChannelChange
  })
  updateSource!: (source: string) => void;

  @Action(ChannelChangeAction.UpdateOffset, {
    namespace: Namespace.ChannelChange
  })
  updateOffset!: (offset: number) => void;

  @Getter(ChannelChangeGetter.GetChannelNumber, {
    namespace: Namespace.ChannelChange
  })
  getChannelNumber!: number[];

  channelList: MyChannel[] = [];
  channelUpdateTimer = 0;

  async mounted(): Promise<void> {
    this.channelList = await apiStorageInterface.fetchCustomChannelList();
  }

  get channelNumberString(): string {
    let channelNum = "";

    for (let i = 0; i < 3 - this.getChannelNumber.length; i++) {
      channelNum = "0" + channelNum;
    }
    this.getChannelNumber.forEach((digit) => {
      channelNum += digit;
    });
    this.timerSet(Number(this.getChannelNumber.join("")));
    return channelNum;
  }

  get channelName(): string {
    let channelNum = Number(this.getChannelNumber.join(""));

    for (let i = 0; i < this.channelList.length; i++) {
      if (this.channelList[i].id === channelNum) {
        return this.channelList[i].name;
      }
    }

    return "Channel not found";
  }

  timerSet(channelNumber: number): void {
    clearTimeout(this.channelUpdateTimer);
    this.channelUpdateTimer = setTimeout(() => {
      for (let i = 0; i < this.channelList.length; i++) {
        if (this.channelList[i].id === channelNumber) {
          this.updateSource(this.channelList[i].videoLive);
          this.updateOffset(0);
        }
      }
      this.updateChanelNumber();
      this.showChannelChange(false);
    }, 3000);
  }
}
